import { ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ClearanceHub, ClearanceResponse } from '@Core/hubs/clearance.hub';
import { Guid } from '@Core/models/guid';
import { AccountsService } from '@Core/services/codegen/accounts.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    standalone: false,
    selector: 'account-clearance-chat-modal',
    templateUrl: './account-clearance-chat-modal.component.html',
    styleUrls: ['./account-clearance-chat-modal.component.scss']
})
export class AccountClearanceChatModalComponent {
    @Input() chats: ClearanceChatVM[] = [];
    @ViewChild('chatwindow') private chatWindow: ElementRef;

    public sessionId: string;
    public waitingForResponse: boolean = false;
    public currentRequest: string;

    constructor(
        public activeModal: NgbActiveModal,
        public accountService: AccountsService,
        public clearanceHub: ClearanceHub,
        private changeDetection: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.sessionId = Guid.newGuid().toString();

        this.clearanceHub.joinChatSession(this.sessionId, (response: ClearanceResponse) => {
            this.chats.push({
                Id: Guid.newGuid().toString(),
                Order: this.chats.length + 1,
                IsRequest: false,
                ResponseBody: response
            });

            this.waitingForResponse = false;
            this.scrollToBottom();
        });
    }

    ngOnDestroy() {
        this.clearanceHub.leaveChatSession(this.sessionId);
    }

    // Add this property to your component class
    public selectedFile: File | null = null;

    // Add this method to handle file selection
    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
        } else {
            this.selectedFile = null;
        }

        if (!this.chats?.length) {
            this.chats = [];
        }
        this.chats.push({
            Id: Guid.newGuid().toString(),
            Order: this.chats.length + 1,
            IsRequest: true,
            RequestText: '[Attached File: ' + this.selectedFile?.name + ']'
        })
    }

    onInput() {
        if (!this.currentRequest)
            return;

        if (!this.chats?.length)
            this.chats = [];

        this.chats.push({
            Id: Guid.newGuid().toString(),
            Order: this.chats.length + 1,
            IsRequest: true,
            RequestText: this.currentRequest
        });

        this.waitingForResponse = true;

        var formData = new FormData();
        formData.append("requestText", this.currentRequest);
        formData.append("SessionId", this.sessionId);
        // Attach the file if one is selected
        if (this.selectedFile) {
            formData.append("file", this.selectedFile);
        }

        this.currentRequest = null;

        this.scrollToBottom();
        this.accountService.ClearanceSubmit(formData).subscribe(
            response => {
                this.selectedFile = null; // Optionally reset after upload
            }
        );
    }

    // We probably want to display the recommended candidate separately, but group them for now.
    getCandidates(chat: ClearanceChatVM) {
        let candidates = [];

        if (chat.ResponseBody?.RecommendedCandidate)
            candidates.push(chat.ResponseBody.RecommendedCandidate);
        if (chat.ResponseBody?.AdditionalCandidates?.length)
            candidates.push(...chat.ResponseBody.AdditionalCandidates);
        return candidates;
    }

    createNewAccount() {
        this.activeModal.close('createNewAccount');
    }

    goToAccount(accountId: string) {
        this.activeModal.close(accountId)
    }

    scrollToBottom(): void {
        this.changeDetection.detectChanges();
        try {
            this.chatWindow.nativeElement.scrollTop = this.chatWindow.nativeElement.scrollHeight;
        } catch(err) { }
    }
};

export interface ClearanceChatVM {
    Id: string;
    Order: number;
    IsRequest: boolean;
    RequestText?: string;
    ResponseBody?: ClearanceResponse;
}
